import React, { FC } from "react";
import { NavLink } from "react-router-dom";
import { SUPPORT_EMAIL } from "../../../constants";
import { ReactComponent as EmailImg } from "../../../assets/illustrations/email-240x240.svg";
import ServicesLayout from "../../../layouts/Services.layout";

export const AuthConfirmPage: FC = () => {
  return (
    <ServicesLayout image={<EmailImg />} title="Almost done!">
      <div className="text-base theme-text-secondary">
        Confirm your email with the link we’ve sent to you. <br />
        <br />
        Didn’t get the email?
        <br /> Please check your <b>Spam</b> and <b>Promotions</b> folders
        <br /> Still can't find it? Then{" "}
        <NavLink to={`mailto:${SUPPORT_EMAIL}`} className="text-blue-500">
          contact customer support
        </NavLink>
        .
      </div>
    </ServicesLayout>
  );
};
